import { useMemo } from 'react';
import businessCollectionComponents, {
  defaultStandardDef,
} from './businessCollectionComponents';
import { IObjektVy } from '../../../../../Types/ObjektVy';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';

interface IProps {
  id: string | null;
  bmod: IClientBusinessModel;
}
const standardComp = (bmod: IClientBusinessModel) => {
  const ObjektVy =
    businessCollectionComponents(bmod.CollectionName).find(
      (comp: IObjektVy) => comp.id === 'standard'
    ) || defaultStandardDef;
  const Comp = ObjektVy.def(bmod).comp;
  return Comp;
};

export const StandardVy = (props: IProps) => {
  const Comp = useMemo(() => standardComp(props.bmod), [props.bmod]);
  return <Comp id={props.id} config={{ fullPage: true, parents: [] }} />;
};
